var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2798_12245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.989 4.34104L16.28 3.30004L18.266 0.0400391L19.975 1.08104L17.989 4.34104ZM23.972 6.36904L23.15 4.54704L19.819 6.05104L20.641 7.87304L23.972 6.36904ZM7.72498 3.30004L5.73898 0.0400391L4.02998 1.08104L6.01498 4.34104L7.72498 3.30004ZM4.18498 6.05104L0.854982 4.54704L0.0319824 6.36904L3.36198 7.87304L4.18498 6.05104ZM7.99998 21V24H16V21.063C16 21.041 16.006 21.021 16.006 21H7.99998ZM6.75598 18.032C7.06398 18.3 7.30398 18.636 7.50298 19H11V13.816C9.83898 13.402 8.99998 12.302 8.99998 11H11C11 11.552 11.448 12 12 12C12.552 12 13 11.552 13 11H15C15 12.302 14.161 13.402 13 13.816V19H16.522C16.726 18.623 16.969 18.275 17.282 17.999C19.01 16.481 20 14.295 20 12C20 9.83904 19.151 7.81304 17.61 6.29704C16.069 4.78104 14.014 3.95904 11.864 4.00104C7.67998 4.07004 4.15498 7.52704 4.00598 11.706C3.91798 14.134 4.91998 16.439 6.75598 18.032Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2798_12245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.a5351dc411e998fb5331606209be1366.svg";
export { ForwardRef as ReactComponent };